import {
  faAirConditioner,
  faBanSmoking,
  faBox,
  faBuilding,
  faCameraCctv,
  faCar,
  faCarBolt,
  faCarGarage,
  faChampagneGlass,
  faChargingStation,
  faCircleQuestion,
  faDoorClosed,
  faDumbbell,
  faElevator,
  faFileContract,
  faFireFlameCurved,
  faFireplace,
  faGrillHot,
  faHouse,
  faHouseHeart,
  faHouseMedical,
  faKey,
  faLaptop,
  faLeaf,
  faMapLocationDot,
  faMountainSun,
  faPaw,
  faPerson,
  faPersonSwimming,
  faPersonWalkingWithCane,
  faPipeSection,
  faPipeValve,
  faSeedling,
  faShelves,
  faShower,
  faSnowflake,
  faSpa,
  faTablePicnic,
  faTeddyBear,
  faTrainSubway,
  faTreeDeciduous,
  faUtensils,
  faVentDamper,
  faWashingMachine,
  faWater,
  faWifi,
} from '@fortawesome/pro-regular-svg-icons';
import type { CustomIconDefinition } from '@/common/custom-icons.ts';

export const faRegularIcons: CustomIconDefinition[] = [
  { library: 'fa-regular', name: 'air-conditioner', icon: faAirConditioner },
  { library: 'fa-regular', name: 'ban-smoking', icon: faBanSmoking },
  { library: 'fa-regular', name: 'box', icon: faBox },
  { library: 'fa-regular', name: 'building', icon: faBuilding },
  { library: 'fa-regular', name: 'camera-cctv', icon: faCameraCctv },
  { library: 'fa-regular', name: 'car', icon: faCar },
  { library: 'fa-regular', name: 'car-bolt', icon: faCarBolt },
  { library: 'fa-regular', name: 'car-garage', icon: faCarGarage },
  { library: 'fa-regular', name: 'champagne-glass', icon: faChampagneGlass },
  { library: 'fa-regular', name: 'charging-station', icon: faChargingStation },
  { library: 'fa-regular', name: 'circle-question', icon: faCircleQuestion },
  { library: 'fa-regular', name: 'door-closed', icon: faDoorClosed },
  { library: 'fa-regular', name: 'dumbbell', icon: faDumbbell },
  { library: 'fa-regular', name: 'elevator', icon: faElevator },
  { library: 'fa-regular', name: 'file-contract', icon: faFileContract },
  { library: 'fa-regular', name: 'fire-flame-curved', icon: faFireFlameCurved },
  { library: 'fa-regular', name: 'fireplace', icon: faFireplace },
  { library: 'fa-regular', name: 'grill-hot', icon: faGrillHot },
  { library: 'fa-regular', name: 'house', icon: faHouse },
  { library: 'fa-regular', name: 'house-heart', icon: faHouseHeart },
  { library: 'fa-regular', name: 'house-medical', icon: faHouseMedical },
  { library: 'fa-regular', name: 'key', icon: faKey },
  { library: 'fa-regular', name: 'laptop', icon: faLaptop },
  { library: 'fa-regular', name: 'leaf', icon: faLeaf },
  { library: 'fa-regular', name: 'map-location-dot', icon: faMapLocationDot },
  { library: 'fa-regular', name: 'mountain-sun', icon: faMountainSun },
  { library: 'fa-regular', name: 'paw', icon: faPaw },
  { library: 'fa-regular', name: 'person', icon: faPerson },
  { library: 'fa-regular', name: 'person-swimming', icon: faPersonSwimming },
  { library: 'fa-regular', name: 'person-walking-with-cane', icon: faPersonWalkingWithCane },
  { library: 'fa-regular', name: 'pipe-section', icon: faPipeSection },
  { library: 'fa-regular', name: 'pipe-valve', icon: faPipeValve },
  { library: 'fa-regular', name: 'seedling', icon: faSeedling },
  { library: 'fa-regular', name: 'shelves', icon: faShelves },
  { library: 'fa-regular', name: 'shower', icon: faShower },
  { library: 'fa-regular', name: 'snowflake', icon: faSnowflake },
  { library: 'fa-regular', name: 'spa', icon: faSpa },
  { library: 'fa-regular', name: 'table-picnic', icon: faTablePicnic },
  { library: 'fa-regular', name: 'teddy-bear', icon: faTeddyBear },
  { library: 'fa-regular', name: 'train-subway', icon: faTrainSubway },
  { library: 'fa-regular', name: 'tree-deciduous', icon: faTreeDeciduous },
  { library: 'fa-regular', name: 'utensils', icon: faUtensils },
  { library: 'fa-regular', name: 'vent-damper', icon: faVentDamper },
  { library: 'fa-regular', name: 'washing-machine', icon: faWashingMachine },
  { library: 'fa-regular', name: 'water', icon: faWater },
  { library: 'fa-regular', name: 'wifi', icon: faWifi },
];
